import { clientViewService } from '@/helpers/clientViewService';
import { AxiosRequestConfig } from 'axios';

/**
 * Builds API request configuration considering "View as Client" mode
 * If "View as Client" mode is enabled, adds X-Client-Id header
 *
 * @param additionalHeaders - Additional headers for the request
 * @returns Axios request configuration object
 */
export const buildClientApiConfig = (
    additionalHeaders: Record<string, string> = {},
): AxiosRequestConfig => {
    const isViewAsClient = clientViewService.isViewAsClient();
    const clientId = clientViewService.getSelectedClientId();

    if (isViewAsClient && clientId) {
        return {
            headers: {
                'X-Client-Id': clientId,
                ...additionalHeaders,
            },
        };
    }

    if (Object.keys(additionalHeaders).length > 0) {
        return {
            headers: additionalHeaders,
        };
    }

    return {};
};
